import React, { useState } from "react";
import config from "./config";
import { devLog } from "./utils/devLog";

function getTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get("token") || "";
}

export default function ResetPassword({ onBack }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const token = getTokenFromUrl();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!password || password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${config.API_URL}/users/reset_password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: password })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || "Failed to reset password.");
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Failed to reset password.");
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div style={{ padding: 40, maxWidth: 400, margin: "40px auto", textAlign: "center" }}>
        <h2>Password Reset Successful</h2>
        <p>You can now log in with your new password.</p>
        <button className="ffb-btn" onClick={() => {
          devLog("Back to Login button clicked");
          if (onBack) {
            onBack();
          }
        }}>Back to Login</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 40, maxWidth: 400, margin: "40px auto" }}>
      <h2 style={{ textAlign: "center" }}>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", marginBottom: 6 }}>New Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #cbd5e1" }}
            minLength={8}
            required
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", marginBottom: 6 }}>Confirm Password</label>
          <input
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #cbd5e1" }}
            minLength={8}
            required
          />
        </div>
        {error && <div style={{ color: "#dc2626", marginBottom: 12 }}>{error}</div>}
        <button className="ffb-btn" type="submit" style={{ width: "100%", padding: 10 }} disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
      <button className="ffb-btn" style={{ marginTop: 18, width: "100%" }} onClick={onBack}>Back</button>
    </div>
  );
} 